import { useDaily } from '@daily-co/daily-react'
import { useEffect, useState } from 'react'
import WarningIcon from '@ui-components-3/icons/lib/solid/TriangleExclamation'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

const DailyConnection = () => {
  const callObject = useDaily()
  const [condition, setCondition] = useState<string>('good')
  const statusMap = {
    poor: 'unstable',
    'very-poor': 'very unstable',
  }
  const bgClass = condition === 'poor' ? 'bg-[#ED9D66]' : 'bg-[#CF0000]'
  const colorClass = condition === 'poor' ? 'text-[black]' : 'text-[white]'
  const status = statusMap[condition] || 'unknown'

  useEffect(() => {
    const updateNetworkInfo = async () => {
      try {
        if (callObject) {
          const { quality } = await callObject.getNetworkStats()
          let condition = 'good'

          if (quality < 51 && quality > 15) {
            condition = 'poor'
          } else if (quality <= 15) {
            condition = 'very-poor'
          }
          setCondition(condition)
        } else {
          setCondition('good')
        }
      } catch (error) {
        console.error('Failed to update network info:', error)
      }
    }
    const interval = setInterval(updateNetworkInfo, 10000)
    return () => clearInterval(interval)
  }, [callObject])

  if (condition !== 'very-poor' && condition !== 'poor') {
    return null
  }

  return (
    <div className="fixed left-0 right-0 top-[210px] sm:top-[175px] md:top-[120px] lg:top-[80px] z-[100] flex items-center justify-center">
      <div
        className={classNames(
          'font-small inline-flex items-center justify-center rounded-full px-4 py-1 text-center font-medium',
          bgClass,
          colorClass,
        )}
      >
        <WarningIcon aria-hidden="true" className="mr-2" />
        Your connection is currently {status}
      </div>
    </div>
  )
}
export default DailyConnection
